/**
 * /tracking/ios-sdk — operator console for the iOS SDK config API (feature #183).
 *
 * Flat-file TanStack route — the `.`-separated name maps to `/tracking/ios-sdk`.
 * Hosts `IosSdkPage` which drives the `/api/v1/ios-sdk` surface: app registry,
 * per-app config editing (events + rate limit + feature flags), and a recent
 * installations pane.
 *
 * Mirrors `tracking.api-tracking.tsx` and the other sibling tracking routes so
 * the central wire-up picks this up through the same pattern. Brand-compliant
 * emerald→sky gradient header, zinc borders, Inter everywhere, light theme.
 */

import { createRoute, Link } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { IosSdkPage } from "@/features/ios-sdk/IosSdkPage";

export const trackingIosSdkRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/tracking/ios-sdk",
	component: TrackingIosSdkRoute,
});

export default trackingIosSdkRoute;

function TrackingIosSdkRoute() {
	return (
		<div className="flex flex-col">
			<nav
				aria-label="Breadcrumb"
				className="mx-auto w-full max-w-5xl px-6 pt-10 text-sm text-zinc-500 sm:pt-16"
			>
				<ol className="flex flex-wrap items-center gap-1">
					<li>
						<Link
							to="/"
							className="rounded-[6px] px-1 py-0.5 hover:bg-zinc-100 hover:text-zinc-900"
						>
							Dashboard
						</Link>
					</li>
					<li aria-hidden="true" className="text-zinc-300">
						/
					</li>
					<li>
						<span className="rounded-[6px] px-1 py-0.5">Tracking</span>
					</li>
					<li aria-hidden="true" className="text-zinc-300">
						/
					</li>
					<li className="text-zinc-900">iOS SDK</li>
				</ol>
			</nav>

			<IosSdkPage />
		</div>
	);
}

// Named export so the central registry wire-up can import the page directly.
export { IosSdkPage } from "@/features/ios-sdk/IosSdkPage";
